export const GET_BANK_SLIP_ENTRY_TRANSACTIONS = 'GET_BANK_SLIP_ENTRY_TRANSACTIONS';
export const BANK_SLIP_ENTRY_TRANSACTION_REQUEST = 'BANK_SLIP_ENTRY_TRANSACTION_REQUEST';
export const BANK_SLIP_ENTRY_TRANSACTION_REQUEST_FAILURE = 'BANK_SLIP_ENTRY_TRANSACTION_REQUEST_FAILURE';